import * as particles from "pixi-particles";
import { Graphics } from "pixi.js";
import particleManager from "slotworks/graphics/particles/particle-manager";
import Point from "slotworks/utils/geom/point";
import Layers from "slotworks/graphics/layers/layers";
import Timer from "slotworks/utils/timer";
import Contract from "slotworks/utils/contract";

export default class ScatterEmitterComponent {

    private emittersLand: Map<number, particles.Emitter>;
    private emittersWin: Map<number, particles.Emitter>;

    public emit(id:number, x: number, y: number) {
        if(!this.emittersLand) 
            this.emittersLand = new Map();
        if(!this.emittersLand.has(id)) {        
            const emitterId = particleManager.add("scatterLand", new Point(x, y), Layers.Custom.get("Animations").container);
            const emitter = particleManager.get(emitterId);
            this.emittersLand.set(id, emitter);
        }
        const currentEmitter = this.emittersLand.get(id);    
        setTimeout(() => {
            currentEmitter.updateSpawnPos(x - 8, y - 70);
            currentEmitter.emit = true;            
            setTimeout(() => { currentEmitter.emit = false;}, 500 );
        }, 200);
    }

    public emitAll(emitters: {id: number, x: number, y: number}[]) {
        if(!this.emittersWin) 
            this.emittersWin = new Map();
        const list: particles.Emitter[] = [];
        for(let em of emitters) {
            if(!this.emittersWin.has(em.id)) {
                const emitterId = particleManager.add("scatterWin", new Point(em.x, em.y), Layers.Custom.get("Animations").container);
                const emitter = particleManager.get(emitterId);
                this.emittersWin.set(em.id, emitter);
            }
            const currentEmitter = this.emittersWin.get(em.id); 
            currentEmitter.updateSpawnPos(em.x - 4, em.y - 80);
            list.push(currentEmitter);
        }
        setTimeout(() => {
            for(let emitter of list) {
                emitter.emit = true;
            }
            setTimeout(() => { 
                for(let emitter of list) {
                    emitter.emit = false;
                    emitter.maxParticles = 40;
                }}, 1200 );
        }, 100);
    }

}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/components/celebrate-win/scatter-emitter-component.ts